/** @jsx jsx */
import { jsx } from "@emotion/core"
import PropTypes from "prop-types"
import { Button as ANTButton } from "antd"
import { btnStyles } from "./styles"
import { useRef } from "react"

/**
- Standard Button component for triggering an operation.
- Based on top of Antd [Button](https://ant.design/components/button/), This button accepts all of antd button props and more.
**/
export const Button = (props) => {
  const { btnType, btnSize, onClick, ...rest } = props
  const btnRef = useRef()
  const onBtnPress = (e) => {
    e.currentTarget.blur()
    if (onClick) {
      onClick()
    }
  }
  return (
    <ANTButton
      {...rest}
      ref={btnRef}
      onClick={onBtnPress}
      css={btnStyles(btnType, btnSize)}
    >
      {props.children}
    </ANTButton>
  )
}

Button.propTypes = {
  /** The type of the button */
  btnType: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "bordered",
    "colorBorder",
  ]),
  /** The size of the button */
  btnSize: PropTypes.oneOf(["large", "small"]),
  /** Disable button */
  disabled: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  onClick: PropTypes.func,
  /** Button content */
  children: PropTypes.node,
}

Button.defaultProps = {
  btnType: "default",
  btnSize: "small",
}
